import { render, staticRenderFns } from "./Scopes.vue?vue&type=template&id=3637f84e"
import script from "./Scopes.vue?vue&type=script&lang=js"
export * from "./Scopes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports